export default {
	Host: "",
	User: "adam22",
	Pass: "Obuvnik69"
}